import { render, staticRenderFns } from "./ex-act.vue?vue&type=template&id=099c7002&scoped=true&"
import script from "./ex-act.vue?vue&type=script&lang=js&"
export * from "./ex-act.vue?vue&type=script&lang=js&"
import style0 from "./ex-act.vue?vue&type=style&index=0&id=099c7002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c7002",
  null
  
)

export default component.exports